import { Box, Grid, Typography } from "@mui/material";
import awardsData from "../../Assets/data/awards.json";
import fellowshipsData from "../../Assets/data/fellowship.json";

const AwardsSection = () => {
  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              Awards and Fellowships
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  fontWeight={600}
                  fontSize="24px"
                  margin="16px 0px 6px"
                >
                  Awards
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {awardsData.map((award, i) => {
                  return (
                    <Typography key={i} style={{ marginBottom: "12px" }}>
                      {award.title}
                    </Typography>
                  );
                })}
              </Grid>
              <Grid item xs={12}>
                <Typography
                  fontWeight={600}
                  fontSize="24px"
                  margin="16px 0px 6px"
                >
                  Fellowships
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {fellowshipsData.map((fellowship, i) => {
                  return (
                    <Box key={i} style={{ marginBottom: "12px" }}>
                      <Typography fontWeight={600} fontSize="20px">
                        {fellowship.fellowship}
                      </Typography>
                      <Typography>{fellowship.university}</Typography>
                      <Typography>{fellowship.location}</Typography>
                      <Typography>{fellowship.year}</Typography>
                    </Box>
                  );
                })}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default AwardsSection;
